import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {filterStyles} from '../shared/styles-filter';
import Toggle from 'material-ui/Toggle';

const jobFilterSelfInputStyles = {
    container: {margin: 0},
    label: {color: '#333333', margin: '-2px 0 0 12px', whiteSpace: 'nowrap'},
    thumbOff: {backgroundColor: '#999999'},
    trackOff: {backgroundColor: '#f0f0f0'},
    thumbOn: {backgroundColor: '#1478b9'}
}

/**
 * A form containing a Text component for Report Job search
 *
 */
class ReportJobsSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            disableSubmit: true
        };
    }

    handleToggle = (e, isChecked) => {
        if (typeof this.props.onToggle === 'function') {
            this.props.onToggle({type: 'self', value: isChecked});
        }
    };

    render() {
        const {instructions} = this.props;

        const styles = {
            instructions: {fontSize: 12, margin: '1em 0 -1em 0'},
            toggle: {display: 'block', margin: '36px 0 0 0'}
        };

        return (
            <div style={filterStyles.reportFilter}>
                {instructions &&
                    <div style={styles.instructions}>
                        View your own Report Jobs.
                    </div>
                }
                <Toggle
                    key="filter_report_job_self"
                    label="View Own Reports"
                    labelPosition="right"
                    style={styles.toggle}
                    labelStyle={jobFilterSelfInputStyles.label}
                    thumbStyle={jobFilterSelfInputStyles.thumbOff}
                    thumbSwitchedStyle={jobFilterSelfInputStyles.thumbOn}
                    trackStyle={jobFilterSelfInputStyles.trackOff}
                    defaultToggled={false}
                    onToggle={this.handleToggle}
                />
            </div>
        );
    }
}

ReportJobsSearch.propTypes = {
    addField: PropTypes.bool,
    instructions: PropTypes.bool,
    onToggle: PropTypes.func
};

ReportJobsSearch.defaultProps = {
    addField: true,
    instructions: false
};

const enhance = compose(
    connect(),
    reduxForm({
        form: 'reportJobFilterForm',
        enableReinitialize: true
    })
);

export default enhance(ReportJobsSearch);



// WEBPACK FOOTER //
// ./src/Fuse/components/ReportJobsFilterSelf.js